import React, { Fragment, useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';
interface StockStatusPanelProps {
  itemBatchInventories?: string;
  productId?: string;
}
interface Batch {
  batchNumber?: string;
  stockAmount?: number;
}

const StockStatusPanel = ({
  itemBatchInventories,
  productId,
}: StockStatusPanelProps) => {
  const [batches, setBatches] = useState<Batch[]>([]);

  const splitStringToObject = (batchInventoryString: string): void => {
    const parts: string[] = batchInventoryString.split(';');

    const objects: Batch[] = [];

    for (const part of parts) {
      const [batchNumber, stockAmount] = part.split(',');
      objects.push({
        batchNumber: batchNumber,
        stockAmount: stockAmount ? parseInt(stockAmount) : 0,
      });
    }

    setBatches(objects);
  };
  useEffect(() => {
    if (!itemBatchInventories) return;
    splitStringToObject(itemBatchInventories);
  }, []);

  return (
    <div>
      <div className="mb-3 text-lg font-bold">
        {translate('detailed-product-card.stock-status')}
      </div>
      <div className="mb-3 flex flex-col gap-3 text-md">
        <div className="flex w-full justify-between font-bold">
          <span>{translate('stockstatuspanel.batchnr')}</span>
          <span>{translate('stockstatuspanel.amount')}</span>
        </div>
        {batches &&
          batches.length > 0 &&
          batches.map((batch, idx) => (
            <Fragment key={'batch' + productId + batch.batchNumber + idx}>
              {batch.batchNumber && batch.stockAmount && (
                <div className="flex justify-between">
                  <span>{batch.batchNumber}</span>
                  <span>{batch.stockAmount}</span>
                </div>
              )}
            </Fragment>
          ))}
      </div>
      <div className="text-md">
        {translate('stockstatuspanel.description')}
      </div>
    </div>
  );
};

export default StockStatusPanel;
